import React from 'react';
import { FormattedMessage } from 'react-intl';

import { BasketDiscountType } from 'apis/restaurant-api/merchant-admin/campaigns/types';
import { Typography } from 'common/typography';

import CampaignFormItem from '../../CampaignFormItem';
import { basketDiscountTypeOptions } from '../../forms/BasketDiscountForm/basketDiscountTypeOptions';

export type DiscountTypeDetailsProps = {
  discountType: BasketDiscountType;
  'data-testid'?: string;
};

export const BasketDiscountTypeDetails = ({ discountType, ...props }: DiscountTypeDetailsProps) => (
  <CampaignFormItem
    data-testid={props['data-testid']}
    title={<FormattedMessage id="campaigns.discount-type.section-title" />}
    value={
      <Typography.Body3>
        <FormattedMessage id={basketDiscountTypeOptions[discountType]} />
      </Typography.Body3>
    }
  />
);
